/* @flow weak */

'use strict';

const React = require('react');
const Reflux = require('reflux');
const _ = require('lodash');

const AnswerStore = require('../../stores/AnswerStore.jsx');
const PartStore = require('../../stores/PartStore.jsx');
const ProductStore = require('../../stores/ProductStore.jsx');

const Config = require('../../configs/Config.js');

const Loader = require('../../loaders');
const ln = Loader.ln || 'en_US';

const PriceSection = React.createClass({
  mixins: [Reflux.connect(AnswerStore, 'answers')],

  getInitialState() {
    return {
      message: undefined,
      price: undefined
    }
  },

  componentWillMount() {
    this.onLoad();
    this.unsubscribeAnswers = AnswerStore.listen(this.onAnswerChange);
  },

  componentWillUnmount() {
    this.unsubscribeAnswers();
  },

  onLoad() {
    let answers = AnswerStore.fetchAll();
    this.onAnswerChange(answers);
  },

  onAnswerChange(answers) {
    let price = AnswerStore.getPrice();
    var country = !_.isNull(ProductStore.getSchoolCountry()) && !_.isEmpty(ProductStore.getSchoolCountry()) 
      && ProductStore.getSchoolCountry() || 'default';
    const currency = _.get(Config, 'currency.' + country) || '$';

    if (price) {
      this.setState({
        message: undefined,
        price: currency + price.toFixed(2)
      });
    } else {
      let startingAtPrice = AnswerStore.getStartingAtPrice();
      this.setState({
        message: Config.features.startingAtText[ln] || Config.features.startingAtText['en_US'],
        price: startingAtPrice ? (currency + startingAtPrice) : 'NO PRICE DATA'
      });
    }
  },



  render() {
    return (
      <div className="uc-product-price">
        <div className="uc-price-message">
          {this.state.message || ''}
        </div>
        
        {this.state.price || ''}
      </div>
    );
  }
});

module.exports = PriceSection;


// WEBPACK FOOTER //
// ./src/base/scripts/components/section/PriceSection.jsx